'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/react/react.js
// module id = 18
// module chunks = 3 4 6 7 10 12 15 18 19 20 21 22